module.exports = __webpack_public_path__ + "img/btn-google.2bd3f476.jpg";